<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />
      <div class="card">
        <div class="title">Daily Omset by Category</div>
        <DataTable
          :value="categoryOmset"
          :paginator="true"
          class="p-datatable-outlets"
          :rows="20"
          :loading="loading"
          data-key="parent_category_id"
          :rowHover="true"
          :scrollable="true"
          scrollDirection="horizontal"
          :expandedRows.sync="expandedRows"
          @rowToggle="onRowToggle"
        >
          <template #header>
            <div class="p-grid p-fluid p-mb-2">
              <div class="p-col">
                <Calendar
                  v-model="start_date"
                  :showIcon="true"
                  dateFormat="yy-mm-dd"
                  placeholder="Start Date"
                  :selectOtherMonths="true"
                  :showButtonBar="true"
                />
              </div>
              <div class="p-col">
                <Calendar
                  v-model="end_date"
                  :showIcon="true"
                  dateFormat="yy-mm-dd"
                  placeholder="End Date"
                  :selectOtherMonths="true"
                  :showButtonBar="true"
                />
              </div>
              <div class="p-col">
                <Button
                  label="Cari"
                  class="p-button-info"
                  @click="getDailyOmsetByCategory()"
                  v-shortkey.push="['enter']"
                  @shortkey="getDailyOmsetByCategory()"
                />
              </div>
              <div class="p-col" v-if="categoryOmset.length > 0">
                <router-link
                  :to="{
                    name: 'print-daily-omset-by-category',
                    query: {
                      start_date: moment(start_date).format('YYYY-MM-DD'),
                      end_date: moment(end_date).format('YYYY-MM-DD'),
                      outlet_id: user.outlet_id
                    }
                  }"
                  target="_blank"
                >
                  <Button
                    label="Print"
                    icon="pi pi-print"
                    class="p-button-success"
                  />
                </router-link>
              </div>
            </div>
            <table
              class="table table-responsive"
              style="font-size: 16px"
              v-if="categoryOmset.length > 0"
            >
              <thead class="thead-light">
                <tr>
                  <th>Metode Pembayaran</th>
                  <th>Jumlah</th>
                  <th>Total Omset</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(an_item, k) in payment_method" :key="k">
                  <td v-if="an_item.name_payment != 'DISCOUNT'">
                    <h5>{{ an_item.name_payment }}</h5>
                  </td>
                  <td v-if="an_item.name_payment != 'DISCOUNT'">
                    {{ an_item.total_payment | currency }}
                  </td>
                  <td v-if="k == 0">{{ totals.total_omset | currency }}</td>
                </tr>
                <tr>
                  <td>
                    <h5>DISCOUNT CASHIER</h5>
                  </td>
                  <td>{{ totals.total_discount | currency }}</td>
                </tr>
                <tr>
                  <td>
                    <h5>DISCOUNT ITEM</h5>
                  </td>
                  <td>{{ totals.total_discount_item | currency }}</td>
                </tr>
              </tbody>
            </table>
            <div
              class="p-grid p-fluid p-mt-3"
              style="font-size: 16px"
              v-if="categoryOmset.length > 0"
            >
              <div class="p-col-12">
                <h4>Ringkasan Total</h4>
              </div>
              <div class="p-col-12 p-md-6 p-lg-3">
                <div class="summary-item">
                  <label>Total Qty:</label>
                  <div>{{ totals.total_qty | number }}</div>
                </div>
              </div>
              <div class="p-col-12 p-md-6 p-lg-3">
                <div class="summary-item">
                  <label>Total Item Amount:</label>
                  <div>{{ totals.total_item_amount | currency }}</div>
                </div>
              </div>
              <div class="p-col-12 p-md-6 p-lg-3">
                <div class="summary-item">
                  <label>Total Diskon Item:</label>
                  <div>{{ totals.total_discount_item | currency }}</div>
                </div>
              </div>
              <div class="p-col-12 p-md-6 p-lg-3">
                <div class="summary-item">
                  <label>Total Diskon:</label>
                  <div>{{ totals.total_discount | currency }}</div>
                </div>
              </div>
              <div class="p-col-12 p-md-6 p-lg-3">
                <div class="summary-item">
                  <label>Total Infaq:</label>
                  <div>{{ totals.total_infaq | currency }}</div>
                </div>
              </div>
              <div class="p-col-12 p-md-6 p-lg-3">
                <div class="summary-item">
                  <label>Total Pembulatan:</label>
                  <div>{{ totals.total_round_up | currency }}</div>
                </div>
              </div>
              <div class="p-col-12 p-md-6 p-lg-3">
                <div class="summary-item">
                  <label>Total Voucher:</label>
                  <div>{{ totals.total_voucher | currency }}</div>
                </div>
              </div>
              <div class="p-col-12 p-md-6 p-lg-3">
                <div class="summary-item">
                  <label>Total Omset:</label>
                  <div>
                    <strong>{{ totals.total_omset | currency }}</strong>
                  </div>
                </div>
              </div>
              <div class="p-col-12 p-md-6 p-lg-3">
                <div class="summary-item">
                  <label>Total Transaksi:</label>
                  <div>{{ totals.total_transactions | number }}</div>
                </div>
              </div>
            </div>
          </template>
          <template #empty>
            <div class="empty-state">
              <i class="pi pi-inbox" style="font-size: 3rem; color: #ccc"></i>
              <p class="empty-message">Data tidak ditemukan.</p>
              <p class="empty-hint">
                Coba ubah rentang tanggal atau pastikan data tersedia untuk
                periode yang dipilih.
              </p>
            </div>
          </template>
          <template #loading>
            <div class="loading-skeleton">
              <div class="skeleton-header">
                <div class="skeleton-line skeleton-title"></div>
                <div class="skeleton-line skeleton-subtitle"></div>
              </div>
              <div class="skeleton-table">
                <div v-for="i in 5" :key="i" class="skeleton-row">
                  <div
                    v-for="j in 10"
                    :key="j"
                    class="skeleton-cell"
                    :style="{
                      width: j === 2 ? '22%' : j === 1 ? '11%' : '10%'
                    }"
                  ></div>
                </div>
              </div>
            </div>
          </template>
          <Column :expander="true" headerStyle="width: 3rem" />
          <Column
            field="parent_category_name"
            header="Grup Kategori"
            headerStyle="text-align: center; width: 16rem"
            bodyStyle="text-align: center; width: 16rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.parent_category_name }}
              </div>
            </template>
          </Column>
          <Column
            field="total_qty"
            header="Total Qty"
            headerStyle="text-align: center; width: 8rem"
            bodyStyle="text-align: center; width: 8rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.total_qty | number }}
              </div>
            </template>
          </Column>
          <Column
            field="total_omset"
            header="Total Omset (Rp)"
            headerStyle="text-align: center; width: 10rem"
            bodyStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                <strong>{{ slotProps.data.total_omset | currency }}</strong>
              </div>
            </template>
          </Column>
          <Column
            field="transaction_count"
            header="Jumlah Transaksi"
            headerStyle="text-align: center; width: 9rem"
            bodyStyle="text-align: center; width: 9rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.transaction_count | number }}
              </div>
            </template>
          </Column>
          <Column
            field="total_item_amount"
            header="Nominal (Rp)"
            headerStyle="text-align: center; width: 10rem"
            bodyStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.total_item_amount | currency }}
              </div>
            </template>
          </Column>
          <Column
            field="total_discount_item"
            header="Diskon Item (Rp)"
            headerStyle="text-align: center; width: 10rem"
            bodyStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.total_discount_item | currency }}
              </div>
            </template>
          </Column>
          <Column
            field="total_discount"
            header="Diskon (Rp)"
            headerStyle="text-align: center; width: 9rem"
            bodyStyle="text-align: center; width: 9rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.total_discount | currency }}
              </div>
            </template>
          </Column>
          <Column
            field="total_infaq"
            header="Infaq (Rp)"
            headerStyle="text-align: center; width: 9rem"
            bodyStyle="text-align: center; width: 9rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.total_infaq | currency }}
              </div>
            </template>
          </Column>
          <Column
            field="total_round_up"
            header="Pembulatan (Rp)"
            headerStyle="text-align: center; width: 10rem"
            bodyStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.total_round_up | currency }}
              </div>
            </template>
          </Column>
          <Column
            field="total_voucher"
            header="Voucher (Rp)"
            headerStyle="text-align: center; width: 9rem"
            bodyStyle="text-align: center; width: 9rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.total_voucher | currency }}
              </div>
            </template>
          </Column>
          <template #expansion="slotProps">
            <div class="expanded-row-container">
              <div class="expanded-row-header">
                <h5>
                  Subcategories untuk
                  <strong>{{ slotProps.data.parent_category_name }}</strong>
                </h5>
                <div class="expanded-row-summary">
                  <span class="summary-badge">
                    Total Subcategories:
                    {{
                      slotProps.data.subcategories &&
                      Array.isArray(slotProps.data.subcategories)
                        ? slotProps.data.subcategories.length
                        : 0
                    }}
                  </span>
                </div>
              </div>
              <div
                v-if="
                  slotProps.data.subcategories &&
                  Array.isArray(slotProps.data.subcategories) &&
                  slotProps.data.subcategories.length > 0
                "
              >
                <DataTable
                  :value="slotProps.data.subcategories"
                  class="p-datatable-sm subcategory-table"
                  :scrollable="true"
                  scrollDirection="horizontal"
                  :rowHover="true"
                  data-key="category_id"
                >
                  <template #empty>
                    <div class="empty-subcategory">Tidak ada subcategory</div>
                  </template>
                  <Column
                    field="category_code"
                    header="Kode Kategori"
                    headerStyle="text-align: center; width: 10rem; background-color: #f5f5f5;"
                    bodyStyle="text-align: center;"
                  >
                    <template #body="subSlotProps">
                      <div style="text-align: center">
                        {{ subSlotProps.data.category_code }}
                      </div>
                    </template>
                  </Column>
                  <Column
                    field="category_name"
                    header="Nama Kategori"
                    headerStyle="text-align: center; width: 20rem; background-color: #f5f5f5;"
                    bodyStyle="text-align: center;"
                  >
                    <template #body="subSlotProps">
                      <div style="text-align: center">
                        {{ subSlotProps.data.category_name }}
                      </div>
                    </template>
                  </Column>
                  <Column
                    field="total_qty"
                    header="Total Qty"
                    headerStyle="text-align: center; width: 10rem; background-color: #f5f5f5;"
                    bodyStyle="text-align: center;"
                  >
                    <template #body="subSlotProps">
                      <div style="text-align: center">
                        {{ subSlotProps.data.total_qty | number }}
                      </div>
                    </template>
                  </Column>
                  <Column
                    field="total_omset"
                    header="Total Omset (Rp)"
                    headerStyle="text-align: center; width: 12rem; background-color: #f5f5f5;"
                    bodyStyle="text-align: center;"
                  >
                    <template #body="subSlotProps">
                      <div style="text-align: center; font-weight: 600">
                        {{ subSlotProps.data.total_omset | currency }}
                      </div>
                    </template>
                  </Column>
                </DataTable>
              </div>
              <div v-else class="empty-subcategory-container">
                <div class="empty-subcategory">
                  <i
                    class="pi pi-info-circle"
                    style="font-size: 1.5rem; margin-right: 0.5rem"
                  />
                  Tidak ada subcategory untuk kategori ini
                </div>
              </div>
            </div>
          </template>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  data() {
    return {
      moment: moment,
      today: new Date().toISOString().split('T')[0],
      loading: true,
      categoryOmset: [],
      payment_method: [],
      totals: {
        total_qty: 0,
        total_item_amount: 0,
        total_discount_item: 0,
        total_discount: 0,
        total_infaq: 0,
        total_round_up: 0,
        total_voucher: 0,
        total_omset: 0,
        total_transactions: 0
      },
      start_date: null,
      end_date: null,
      expandedRows: [],
      maxDateRange: 365, // Maximum date range in days
      retryCount: 0,
      maxRetries: 3
    }
  },
  mounted() {
    // Fix race condition: Initialize dates first, then fetch data
    this.initializeDates()
    this.$nextTick(() => {
      this.getDailyOmsetByCategory()
    })
  },
  methods: {
    /**
     * Initialize default date values
     */
    initializeDates() {
      this.start_date = this.today
      this.end_date = this.today
    },

    /**
     * Validate date range
     * @returns {boolean} True if valid, false otherwise
     */
    validateDateRange() {
      const start_date = this.start_date
        ? moment(this.start_date).format('YYYY-MM-DD')
        : this.today
      const end_date = this.end_date
        ? moment(this.end_date).format('YYYY-MM-DD')
        : this.today

      // Check if end date is before start date
      if (end_date < start_date) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Warning',
          detail:
            'Tanggal akhir harus lebih besar atau sama dengan tanggal awal',
          life: 3000
        })
        return false
      }

      // Check if date range exceeds maximum allowed
      const startMoment = moment(start_date)
      const endMoment = moment(end_date)
      const daysDiff = endMoment.diff(startMoment, 'days')

      if (daysDiff > this.maxDateRange) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Warning',
          detail: `Rentang tanggal tidak boleh lebih dari ${this.maxDateRange} hari`,
          life: 3000
        })
        return false
      }

      // Check if dates are in the future
      const todayMoment = moment(this.today)
      if (startMoment.isAfter(todayMoment) || endMoment.isAfter(todayMoment)) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Warning',
          detail: 'Tanggal tidak boleh melebihi tanggal hari ini',
          life: 3000
        })
        return false
      }

      return true
    },

    /**
     * Fetch daily omset by category data with retry mechanism
     */
    getDailyOmsetByCategory() {
      // Validate date range before making API call
      if (!this.validateDateRange()) {
        this.loading = false
        return
      }

      this.loading = true
      this.retryCount = 0

      const start_date = this.start_date
        ? moment(this.start_date).format('YYYY-MM-DD')
        : this.today
      const end_date = this.end_date
        ? moment(this.end_date).format('YYYY-MM-DD')
        : this.today

      this.fetchData(start_date, end_date)
    },

    /**
     * Handle row toggle event for debugging
     * @param {Object} event - Row toggle event
     */
    onRowToggle(event) {
      console.log('Row Toggle Event:', event)
      console.log('Expanded Rows:', this.expandedRows)
      console.log('Event Data:', event.data)
      if (event.data) {
        console.log('Row Data:', {
          parent_category_id: event.data.parent_category_id,
          parent_category_name: event.data.parent_category_name,
          has_subcategories: !!event.data.subcategories,
          subcategories_count: event.data.subcategories
            ? event.data.subcategories.length
            : 0,
          subcategories: event.data.subcategories
        })
      }
    },

    /**
     * Fetch data from API with retry mechanism
     * @param {string} start_date - Start date in YYYY-MM-DD format
     * @param {string} end_date - End date in YYYY-MM-DD format
     */
    fetchData(start_date, end_date) {
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/pos/dailyomset/by-category-parent?start_date=${start_date}&end_date=${end_date}`,
          {
            timeout: 30000 // 30 second timeout
          }
        )
        .then(response => {
          if (response.status === 200) {
            this.loading = false
            this.retryCount = 0 // Reset retry count on success

            const categoryOmsetData = response.data.data.category_omset || []

            // Debug: Log data structure
            console.log('=== API Response Debug ===')
            console.log('Total categories:', categoryOmsetData.length)
            if (categoryOmsetData.length > 0) {
              console.log('First category structure:', {
                parent_category_id: categoryOmsetData[0].parent_category_id,
                parent_category_name: categoryOmsetData[0].parent_category_name,
                has_subcategories: !!categoryOmsetData[0].subcategories,
                subcategories_type: typeof categoryOmsetData[0].subcategories,
                is_array: Array.isArray(categoryOmsetData[0].subcategories),
                subcategories_count: categoryOmsetData[0].subcategories
                  ? categoryOmsetData[0].subcategories.length
                  : 0,
                subcategories_sample: categoryOmsetData[0].subcategories
                  ? categoryOmsetData[0].subcategories.slice(0, 2)
                  : null,
                full_first_item: categoryOmsetData[0]
              })

              // Check all items for subcategories
              const itemsWithSubcategories = categoryOmsetData.filter(
                item => item.subcategories && item.subcategories.length > 0
              )
              console.log(
                'Items with subcategories:',
                itemsWithSubcategories.length,
                'out of',
                categoryOmsetData.length
              )
            }
            console.log('=== End Debug ===')

            this.categoryOmset = categoryOmsetData
            this.payment_method = response.data.data.payment || []
            this.totals = response.data.data.totals || {
              total_qty: 0,
              total_item_amount: 0,
              total_discount_item: 0,
              total_discount: 0,
              total_infaq: 0,
              total_round_up: 0,
              total_voucher: 0,
              total_omset: 0,
              total_transactions: 0
            }
            // Reset expanded rows when new data is loaded
            this.expandedRows = []
          }
        })
        .catch(error => {
          this.handleError(error, start_date, end_date)
        })
    },

    /**
     * Handle API errors with retry mechanism
     * @param {Error} error - The error object
     * @param {string} start_date - Start date for retry
     * @param {string} end_date - End date for retry
     */
    handleError(error, start_date, end_date) {
      let errorMessage = 'Gagal mengambil data omset by category'
      let shouldRetry = false

      // Determine error type and message
      if (error.response) {
        // Server responded with error status
        const status = error.response.status
        if (status >= 500) {
          // Server error - retry
          errorMessage = 'Terjadi kesalahan pada server. Mencoba lagi...'
          shouldRetry = true
        } else if (status === 404) {
          errorMessage = 'Endpoint tidak ditemukan'
        } else if (status === 401 || status === 403) {
          errorMessage = 'Tidak memiliki akses untuk melihat data ini'
        } else if (error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message
        }
      } else if (error.request) {
        // Request made but no response (network error)
        errorMessage = 'Tidak dapat terhubung ke server. Mencoba lagi...'
        shouldRetry = true
      } else if (error.code === 'ECONNABORTED') {
        // Timeout
        errorMessage = 'Waktu tunggu habis. Mencoba lagi...'
        shouldRetry = true
      } else {
        errorMessage = error.message || errorMessage
      }

      // Retry logic
      if (shouldRetry && this.retryCount < this.maxRetries) {
        this.retryCount++
        const retryDelay = Math.pow(2, this.retryCount) * 1000 // Exponential backoff

        this.$toast.add({
          severity: 'warn',
          summary: 'Mencoba Lagi',
          detail: `${errorMessage} (Percobaan ${this.retryCount}/${this.maxRetries})`,
          life: 2000
        })

        setTimeout(() => {
          this.fetchData(start_date, end_date)
        }, retryDelay)
      } else {
        // Max retries reached or non-retryable error
        this.loading = false
        this.retryCount = 0

        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: shouldRetry
            ? 'Gagal mengambil data setelah beberapa percobaan. Silakan coba lagi nanti.'
            : errorMessage,
          life: 5000
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.qty {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50px;
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

.summary-item {
  padding: 0.5rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 0.5rem;

  label {
    display: block;
    font-weight: bold;
    margin-bottom: 0.25rem;
    font-size: 0.875rem;
    color: #666;
  }

  div {
    font-size: 1rem;
    color: #333;
  }
}

/* Expanded Row Styling */
.expanded-row-container {
  padding: 1.5rem;
  background-color: #fafafa;
  border-left: 4px solid #007ad9;
}

.expanded-row-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #e0e0e0;

  h5 {
    margin: 0;
    color: #333;
    font-size: 1.1rem;

    strong {
      color: #007ad9;
    }
  }
}

.expanded-row-summary {
  display: flex;
  gap: 0.5rem;
}

.summary-badge {
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 600;
}

.subcategory-table {
  margin-top: 1rem;
  background-color: white;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.empty-subcategory-container {
  padding: 2rem;
  text-align: center;
  background-color: white;
  border-radius: 4px;
  margin-top: 1rem;
}

.empty-subcategory {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 1rem;
  padding: 1rem;
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}

::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}

/* Loading Skeleton Styles */
.loading-skeleton {
  padding: 2rem;
}

.skeleton-header {
  margin-bottom: 1.5rem;
}

.skeleton-title {
  height: 24px;
  width: 60%;
  margin-bottom: 0.75rem;
}

.skeleton-subtitle {
  height: 16px;
  width: 40%;
}

.skeleton-table {
  width: 100%;
}

.skeleton-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 0.75rem 0;
}

.skeleton-cell {
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
  border-radius: 4px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Empty State Styles */
.empty-state {
  text-align: center;
  padding: 3rem 2rem;
  color: #666;
}

.empty-message {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 1rem 0 0.5rem;
  color: #333;
}

.empty-hint {
  font-size: 0.875rem;
  color: #999;
  margin: 0;
}
</style>
